import { showMessage, loadingEnd, loadingStart, showError, showPopup } from "./uiActions";
import { setDataSource } from './databaseActions'

export function showQuery(payload) {
    return { 'type': 'SHOW_QUERY', payload}
}

export function clearQuery() {
    return { 'type': 'CLEAR_QUERY'}
}

export function setGlobal(payload) {
    return { 'type': 'SET_GLOBAL', payload}
}

export function setCurrentQPs(payload) {
    return { 'type': 'SET_QUICK_PICK', payload }
}

export function saveChangedGlobal(payload) {
    return { 'type': 'SAVE_CHANGED_GLOBAL', payload }
}

export function saveChangedQPs(payload) {
    return { 'type': 'SAVE_CHANGED_QUICK_PICKS', payload }
}

export function getQuery(id) {
    return function (dispatch) {
        dispatch(loadingStart())
        fetch(`${process.env.REACT_APP_BACK_URL}/queries/${id}`, {
            method: 'GET',
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem("jwt_token")}`
            },
        }).then((resp) => {
            if (resp.status !== 200) {
                throw new Error()
            } else {
                return resp.json()
            }
        })
            .then((json) => {
                dispatch(loadingEnd())
                dispatch(setDataSource(json.query.chartOptions.query.info.connection.dataSource))
                return dispatch(showQuery(json.query))
            }).catch((ex) => {
                dispatch(showError())
                dispatch(loadingEnd())
                return dispatch(showMessage("Get Query Failed", false))
            })
    }
}

export function changeGlobal(globalId, connId, dsAlias, arr) {
    return function (dispatch) {
        //dispatch(loadingStart())
        fetch(`${process.env.REACT_APP_BACK_URL}/queries/globals/${globalId}}`, {
            method: 'POST',
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem("jwt_token")}`
            },
            body: JSON.stringify({
                ID: globalId,
                ConnID: connId,
                DataSourceAlias: dsAlias,
                NameArray: arr,
            })
        }).then((resp) => {
            if (resp.status !== 200) {
                throw new Error()
            } else {
                return resp.json()
            }
        }).then((json) => {
            dispatch(showMessage("Global Edit Was Successful", true))
            return dispatch(saveChangedGlobal(json.global))
        }).catch((ex) => {
            dispatch(showError())
            dispatch(loadingEnd())
            return dispatch(showMessage("Global Edit Failed. Please Try Again", false))
        })
    }
}

export function changeQPs(editQuickPickIDs, connId, quickPickAliases) {
    return function (dispatch) {
        dispatch(showPopup("loadingPopup", "Saving QP Changes..."))
        fetch(`${process.env.REACT_APP_BACK_URL}/queries/quickpicks/${editQuickPickIDs[0]}`, {
            method: 'POST',
            headers: {
                'accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem("jwt_token")}`
            },
            body: JSON.stringify({
                EditQuickPickIDs: editQuickPickIDs,
                ConnID: connId,
                QuickPickAliases: quickPickAliases,
            })
        }).then((resp) => {
            if (resp.status !== 200) {
                throw new Error()
            } else {
                return resp.json()
            }
        }).then((json) => {
            dispatch(showPopup("confirmationPopup", "Quick Picks Edit Was Successful", true))
            return dispatch(saveChangedQPs(json.editQuickPickTags))
        }).catch((ex) => {
            return dispatch(showPopup("confirmationPopup", "Quick Picks Edit Failed. Please Try Again", false))
        })
    }
}